export enum ETransactionStatus {
    WAITING = 'waiting',
    SUCCESS = 'success',
    FAIL = 'FAIL',
}
